import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61d89f2e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "work__items" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_work_item = _resolveComponent("work-item")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.works, (work) => {
      return (_openBlock(), _createBlock(_component_work_item, {
        key: work.id,
        id: work.id,
        title: work.title,
        banner: work.banner,
        width: work.width,
        height: work.height,
        tags: work.tags,
        info: work.info,
        "open-modal": () => _ctx.openModal(work)
      }, null, 8, ["id", "title", "banner", "width", "height", "tags", "info", "open-modal"]))
    }), 128))
  ]))
}